import { useQuery } from '@tanstack/react-query';

import { gitOpsWorkflowDeploymentResources } from '@api/sdk.gen';
import { EngineResource } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

import { workflowQueryKeys } from '../../queries/query-keys';

async function getDeploymentResources(
  workflowId: number,
  deploymentId: number
): Promise<Array<EngineResource>> {
  const { data } = await gitOpsWorkflowDeploymentResources({
    path: { id: workflowId, deploymentId },
  });

  return data ?? [];
}

/**
 * Reads what a reconciled deployment declares.
 *
 * Fetched when it is asked for rather than carried on the workflow, because a
 * deployment can declare hundreds of resources and the list is the same for
 * every environment running it.
 */
export function useDeploymentResources(
  workflowId: number,
  deploymentId: number,
  { enabled }: { enabled: boolean }
) {
  return useQuery({
    queryKey: workflowQueryKeys.deploymentResources(workflowId, deploymentId),
    queryFn: () => getDeploymentResources(workflowId, deploymentId),
    enabled,
    ...withError('Unable to load deployment resources'),
  });
}
